module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"

  siteTitle: 'Not Dropping Cameras', // Navigation and Site Title
  siteTitleAlt: 'Not Dropping Cameras - Hugh Dyar IV Photography Portfolio', // Alternative Site title for SEO
  siteUrl: 'http://hdyar.com/ndc2018', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: '/logos/logo-1024.png', // Used for SEO and manifest
  siteDescription: 'The photography of Hugh Huntington Dyar IV',

  siteFBAppID: '', // Facebook App ID
  userTwitter: 'hdyar', // Twitter Username
  ogSiteName: 'hunterdyar', // Facebook Site Name
  googleAnalyticsID: 'UA-1588238-21',

  // Date format used in your project
  // More information here: https://date-fns.org/v1.29.0/docs/format
  dateFormat: 'DD.MM.YYYY',

  // Manifest and Progress color
  themeColor: '#3D3D3D',
  backgroundColor: '#2b2e3c',

  // Settings for typography.js
  headerFontFamily: 'Open Sans',
  bodyFontFamily: 'Merriweather',
  baseFontSize: '16px',

  // Your information
  avatar: '',
  name: 'Not Dropping Cameras',
  location: 'Pittsburgh, PA',
  socialMedia: [
    {
      url: 'https://www.instagram.com/notdroppingcameras',
      name: 'Instagram',
    },
        {
      url: 'https://www.blog.notdroppingcameras.com',
      name: 'Blog',
    },
      {
      url: 'mailto:smokey@notdroppingcameras.com',
      name: 'Email',
    }
  ],
};




// WEBPACK FOOTER //
// ./config/SiteConfig.js